import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { NgxSpinnerService } from 'ngx-spinner';
import * as pako from 'pako';
import { from, Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiServiceService {
  constructor(
    private http: HttpClient,
    private afAuth: AngularFireAuth,
    private spinner: NgxSpinnerService
  ) {}

  sendPostRequest<T>(endpoint: string, body: object): Observable<T | null> {
    this.spinner.show();
    const mainPath = environment.cloudApi.path;
    const url = `${mainPath}/${endpoint}`;
    console.log(body);

    return from(this.afAuth.currentUser).pipe(
      switchMap((user) => {
        if (!user) {
          this.spinner.hide();
          return of(null);
        }
        return from(user.getIdToken());
      }),
      switchMap((token) => {
        if (!token) {
          this.spinner.hide();
          return of(null);
        }

        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
          'api-key': 'NvFulM03vIzOzDBi3LNpRyufdlUj8cz3UisZKGDncVPgpPYeCN',
        });

        // Compress the body using pako (GZIP compression)
        const bodyToCompress = JSON.stringify(body); // JSON.stringify to send the body as JSON
        const compressedBody = pako.gzip(bodyToCompress); // pako.gzip directly compresses the stringified body

        // Create FormData to send the GZIP data
        const formData = new FormData();
        formData.append('file', new Blob([compressedBody]), 'data.gz'); // Append the GZIP data as a file

        return this.http.post(url, formData, { headers }).pipe(
          map((response: any) => {
            this.spinner.hide();
            return response as T;
          }),
          catchError((error) => {
            this.spinner.hide();
            console.error('Error in POST request:', error);
            return of(null);
          })
        );
      })
    );
  }
}
